/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { TabValue } from "../config";
import { TAB_CONFIG } from "../config";

interface LoadingStateProps {
  tab: TabValue;
}

export const LoadingState = defineComponent<LoadingStateProps>({
  name: "LoadingState",
  props: ["tab"] as any,
  setup(props) {
    const { t } = useLocalization();

    return () => {
      const config = TAB_CONFIG[props.tab];
      const label = config.type === "request" ? "requests" : "reservations";

      return (
        <div class="flex items-center justify-center h-96">
          <div class="text-center">
            <div class="relative inline-block">
              <div class="w-16 h-16 border-4 border-primary/20 border-t-primary rounded-full animate-spin"></div>
              <span class="material-symbols-outlined text-primary text-2xl absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                table_restaurant
              </span>
            </div>
            <p class="mt-6 text-sm font-medium text-base-content/70">
              Loading {label}...
            </p>
          </div>
        </div>
      );
    };
  },
});
